import { render, staticRenderFns } from "./PrintPosFacturaTicketComandas.vue?vue&type=template&id=f1e310b8&scoped=true"
import script from "./PrintPosFacturaTicketComandas.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaTicketComandas.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaTicketComandas.vue?vue&type=style&index=0&id=f1e310b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e310b8",
  null
  
)

export default component.exports